import { atom } from "jotai";

const mandatoryOptionGroupsAtom = atom<Record<string, boolean>>({})

export default mandatoryOptionGroupsAtom
